<template>
  <div>
    <notifications />
  </div>
</template>

<script>
import Notifications from '@/components/Notifications.vue';

export default {
  metaInfo: {
    title: 'Notifications',
  },
  components: {
    Notifications,
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .notifications-list {
    margin: 0 -15px;
    border-bottom: 1px solid var(--gray);
  }

  @media (min-width: 1024px) {
    /deep/ .notifications-list {
      margin-right: 0;
      margin-left: 0;
      border-right: 1px solid var(--gray);
      border-left: 1px solid var(--gray);
    }
  }
</style>
